export default function Values() {
  const values = [
    {
      icon: 'ri-shield-star-line',
      title: 'Integrity',
      description: 'We conduct our business with the highest ethical standards, maintaining transparency and honesty in all our dealings with healthcare partners and patients.',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      icon: 'ri-award-line',
      title: 'Excellence',
      description: 'We strive for excellence in everything we do, from product quality to customer service, ensuring we exceed industry standards and expectations.',
      color: 'from-cyan-500 to-teal-500'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Compassion',
      description: 'We understand the critical nature of healthcare and approach our work with empathy, ensuring patients receive the care and medicines they need.',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Innovation',
      description: 'We embrace innovation and continuously seek new ways to improve our products, services, and processes to better serve the healthcare community.',
      color: 'from-cyan-500 to-teal-500'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Accountability',
      description: 'We take full responsibility for our actions and decisions, ensuring that we deliver on our promises and maintain the trust placed in us.',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      icon: 'ri-team-line',
      title: 'Collaboration',
      description: 'We believe in the power of teamwork and partnership, working closely with healthcare professionals to achieve better patient outcomes.',
      color: 'from-cyan-500 to-teal-500'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
            OUR VALUES
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
            The Principles That Guide Us
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
            Our core values define who we are and how we operate. They guide our decisions, shape our culture, and drive our commitment to excellence in pharmaceutical care.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${value.color} rounded-2xl mb-6`}>
                <i className={`${value.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{value.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
